// ─── Query Keys ───────────────────────────────────────────────────────────────

export const taskKeys = {
  all: ['tasks'] as const,
  history: (id: string): readonly unknown[] => [...taskKeys.all, 'history', id] as const,
};
